<template>
  <div class="fillReportComponent">
    <Modal :visible="true" title="动脉瘤参数" width="760px">
      <div class="fillReportContent">
        <fieldset class="blockFieldSet">
          <legend>患者手术综合评估建议</legend>
          <div class="labelText">评估结论</div>
          <TextArea />
        </fieldset>
        <fieldset class="blockFieldSet">
          <legend>动脉瘤术前分析</legend>
          <div class="uploadContentWrap">
            <Upload name="file" :multiple="true" list-type="picture-card" class="uploader">
              <div class="uploadFileTip">
                <Icon type="plus" />
                <div class="ant-upload-text">Upload</div>
              </div>
            </Upload>
            <Upload name="file" :multiple="true" list-type="picture-card" class="uploader">
              <div class="uploadFileTip">
                <Icon type="plus" />
                <div class="ant-upload-text">Upload</div>
              </div>
            </Upload>
            <Upload name="file" :multiple="true" list-type="picture-card" class="uploader">
              <div class="uploadFileTip">
                <Icon type="plus" />
                <div class="ant-upload-text">Upload</div>
              </div>
            </Upload>
            <Upload name="file" :multiple="true" list-type="picture-card" class="uploader">
              <div class="uploadFileTip">
                <Icon type="plus" />
                <div class="ant-upload-text">Upload</div>
              </div>
            </Upload>
          </div>
        </fieldset>
        <fieldset class="blockFieldSet">
          <legend>动脉瘤形态</legend>
          <div class="uploadContentWrap">
            <Upload name="file" :multiple="true" list-type="picture-card" class="uploader">
              <div class="uploadFileTip">
                <Icon type="plus" />
                <div class="ant-upload-text">Upload</div>
              </div>
            </Upload>
            <Upload name="file" :multiple="true" list-type="picture-card" class="uploader">
              <div class="uploadFileTip">
                <Icon type="plus" />
                <div class="ant-upload-text">Upload</div>
              </div>
            </Upload>
            <Upload name="file" :multiple="true" list-type="picture-card" class="uploader">
              <div class="uploadFileTip">
                <Icon type="plus" />
                <div class="ant-upload-text">Upload</div>
              </div>
            </Upload>
            <Upload name="file" :multiple="true" list-type="picture-card" class="uploader">
              <div class="uploadFileTip">
                <Icon type="plus" />
                <div class="ant-upload-text">Upload</div>
              </div>
            </Upload>
          </div>
        </fieldset>
        <fieldset class="blockFieldSet">
          <legend>形态学指标分析</legend>
          <div class="item">
            <div class="labelText">颅内动脉瘤大小(长径) Hmax</div>
            <Input addon-after="mm" />
            <Upload name="file" :multiple="true" list-type="picture-card" class="uploader">
              <div class="uploadFileTip">
                <Icon type="plus" />
                <div class="ant-upload-text">Upload</div>
              </div>
            </Upload>
          </div>
           <div class="item">
            <div class="labelText">颅内动脉瘤大小(长径) Hmax</div>
            <Input addon-after="mm" />
            <Upload name="file" :multiple="true" list-type="picture-card" class="uploader">
              <div class="uploadFileTip">
                <Icon type="plus" />
                <div class="ant-upload-text">Upload</div>
              </div>
            </Upload>
          </div>
           <div class="item">
            <div class="labelText">颅内动脉瘤体宽度(宽径) SW</div>
            <Input addon-after="mm" />
            <Upload name="file" :multiple="true" list-type="picture-card" class="uploader">
              <div class="uploadFileTip">
                <Icon type="plus" />
                <div class="ant-upload-text">Upload</div>
              </div>
            </Upload>
          </div>
           <div class="item">
            <div class="labelText">颅内动脉瘤体横径 ST</div>
            <Input addon-after="mm" />
            <Upload name="file" :multiple="true" list-type="picture-card" class="uploader">
              <div class="uploadFileTip">
                <Icon type="plus" />
                <div class="ant-upload-text">Upload</div>
              </div>
            </Upload>
          </div>
           <div class="item">
            <div class="labelText">颅内动脉瘤高度 H</div>
            <Input addon-after="mm" />
            <Upload name="file" :multiple="true" list-type="picture-card" class="uploader">
              <div class="uploadFileTip">
                <Icon type="plus" />
                <div class="ant-upload-text">Upload</div>
              </div>
            </Upload>
          </div>
           <div class="item">
            <div class="labelText">载瘤动脉直径 PAD</div>
            <Input addon-after="mm" />
            <Upload name="file" :multiple="true" list-type="picture-card" class="uploader">
              <div class="uploadFileTip">
                <Icon type="plus" />
                <div class="ant-upload-text">Upload</div>
              </div>
            </Upload>
          </div>
           <div class="item">
            <div class="labelText">颅内动脉瘤颈直径 ND</div>
            <Input addon-after="mm" />
            <Upload name="file" :multiple="true" list-type="picture-card" class="uploader">
              <div class="uploadFileTip">
                <Icon type="plus" />
                <div class="ant-upload-text">Upload</div>
              </div>
            </Upload>
          </div>
           <div class="item">
            <div class="labelText">动脉瘤入射角度 AIF</div>
            <Input addon-after="度" />
            <Upload name="file" :multiple="true" list-type="picture-card" class="uploader">
              <div class="uploadFileTip">
                <Icon type="plus" />
                <div class="ant-upload-text">Upload</div>
              </div>
            </Upload>
          </div>
          <div class="item">
            <div class="labelText">颅内动脉瘤体积 V</div>
            <Input addon-after="mm^3" />
            <Upload name="file" :multiple="true" list-type="picture-card" class="uploader">
              <div class="uploadFileTip">
                <Icon type="plus" />
                <div class="ant-upload-text">Upload</div>
              </div>
            </Upload>
          </div>
          <div class="item">
            <div class="labelText">颅内动脉瘤表面积 SA</div>
            <Input addon-after="mm^2" />
            <Upload name="file" :multiple="true" list-type="picture-card" class="uploader">
              <div class="uploadFileTip">
                <Icon type="plus" />
                <div class="ant-upload-text">Upload</div>
              </div>
            </Upload>
          </div>
          <div class="item">
            <div class="labelText">动脉瘤非球形指数 NSI</div>
            <Input />
          </div>
          
          <div class="item">
            <div class="labelText">动脉瘤尺寸比 SR</div>
            <Input />
            <Upload name="file" :multiple="true" list-type="picture-card" class="uploader">
              <div class="uploadFileTip">
                <Icon type="plus" />
                <div class="ant-upload-text">Upload</div>
              </div>
            </Upload>
          </div>

          <div class="item">
            <div class="labelText">动脉瘤纵横比 AR</div>
            <Input />
            <Upload name="file" :multiple="true" list-type="picture-card" class="uploader">
              <div class="uploadFileTip">
                <Icon type="plus" />
                <div class="ant-upload-text">Upload</div>
              </div>
            </Upload>
          </div>

          <div class="item">
            <div class="labelText">动脉瘤长宽比 WHR</div>
            <Input />
            <Upload name="file" :multiple="true" list-type="picture-card" class="uploader">
              <div class="uploadFileTip">
                <Icon type="plus" />
                <div class="ant-upload-text">Upload</div>
              </div>
            </Upload>
          </div>

          <div class="item">
            <div class="labelText">瘤体宽径与瘤颈比 BNR</div>
            <Input />
            <Upload name="file" :multiple="true" list-type="picture-card" class="uploader">
              <div class="uploadFileTip">
                <Icon type="plus" />
                <div class="ant-upload-text">Upload</div>
              </div>
            </Upload>
          </div>


          <div class="item">
            <div class="labelText">壁面剪应力均值 WSSA</div>
            <Input />
          </div>
          
          <div class="item">
            <div class="labelText">归一化壁面剪应力均值 NWSSA</div>
            <Input />
          </div>

          <div class="item">
            <div class="labelText">壁面剪应力最大值 MWSS</div>
            <Input />
          </div>

          <div class="item">
            <div class="labelText">归一化壁面剪应力最大值 NWSSM</div>
            <Input />
          </div>

          <div class="item">
            <div class="labelText">压力均值 PA</div>
            <Input addon-after="pa"/>
          </div>
          <div class="item">
            <div class="labelText">归一化压力均值 NPA</div>
            <Input addon-after="pa"/>
          </div>

          <div class="item">
            <div class="labelText">壁面剪应力梯度 WSSG</div>
            <Input />
          </div>

          <div class="item">
            <div class="labelText">低壁面切应力面积比 LSAR</div>
            <Input />
          </div>

          <div class="item">
            <div class="labelText">切应力振荡指数 OSI</div>
            <Input />
          </div>

          <div class="item">
            <div class="labelText">相对停留时间 RRT</div>
            <Input />
          </div>

        </fieldset>
      </div>
    </Modal>
  </div>  
</template>
<script>
import { Input , Modal, Upload, Icon } from 'ant-design-vue'
export default {
  components: {
    Modal,
    TextArea: Input.TextArea,
    Upload,
    Icon,
    Input
  }
}
</script>
<style lang="less">
.fillReportContent{
  .blockFieldSet{
    padding: 10px;
    border: 1px solid #d9d9d9;
    border-radius: 5px;
    legend{
      font-size: 18px;
      width: auto;
      font-weight: bold;
    }
  }
  
  
  .labelText{
    font-size: 16px;
    margin-bottom: 5px;
  }
  .uploadContentWrap{
    .uploader{
      display: inline-block;
    }
  }
  .uploadFileTip i {
    font-size: 32px;
    color: #999;
  }

  .uploadFileTip .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }
}
</style>